import React from 'react';
import { trimString, formatText } from '../../utils';
// eslint-disable-next-line
import variables from '../../styles/variables.module.scss';

interface CaptionProps {
  children: string;
  maxLength?: number;
  service: string;
  color?: string;
  disableLinks: boolean;
  innerRef: any;
}

const Caption: React.FC<CaptionProps> = ({
  children,
  maxLength,
  service,
  color = variables.primaryColor,
  disableLinks,
  innerRef,
}) => {
  const caption = trimString(children, maxLength);
  const html = formatText(caption, { service, color, disableLinks });

  return (
    <div
      dangerouslySetInnerHTML={html}
      ref={innerRef}
      style={{ height: '100%', width: '100%', maxHeight: '1500px', maxWidth: '1500px' }}
      data-testid="captionWrapper"
    />
  );
};

export default React.memo(
  Caption,
  (prevProps, nextProps) => nextProps.children === prevProps.children
);
